import React from 'react';
import { ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const rows = [{
  label: '📚 THE ACADEMIC EDGE (12 Volumes)',
  price: '$25'
}, {
  label: '🎁 The AI Prompt Library (PDF)',
  price: 'FREE'
}, {
  label: '🎁 The High-Performance Notion Template',
  price: 'FREE'
}, {
  label: '🎁 The 24-Hour Exam Emergency Checklist',
  price: 'FREE'
}, {
  label: '🎁 The Ivy League Networking Scripts (PDF)',
  price: 'FREE'
}, {
  label: '🎁 The Student Side-Hustle Blueprint (PDF)',
  price: 'FREE'
}, {
  label: '🛡️ 7-Day Guarantee',
  price: 'INCLUDED'
}];
const trust = [{
  icon: LockIcon,
  label: '100% Secure Payment'
}, {
  icon: ZapIcon,
  label: 'Immediate Access'
}, {
  icon: ShieldCheckIcon,
  label: '7-Day Guarantee'
}, {
  icon: CreditCardIcon,
  label: 'Debit / Credit'
}];
export function ValueStack() {
  return <section id="value" aria-label="Offer summary" className="border-y border-white/5 bg-ink-2" data-id="element-173" data-mp="35ov48ddrnr42">
      <div className="mx-auto max-w-2xl px-5 py-12 text-center" data-id="element-174" data-mp="1tf3g6190cj35">
        <h2 className="font-display text-2xl font-black text-white sm:text-4xl" data-id="element-175" data-mp="1tda9ilye9yv5">
          🚀 Start Passing From Today
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-sm text-white/60" data-id="element-176" data-mp="234wi0ajclju7">
          For less than the cost of a single set of printed notes you get lifetime access. The
          entire system ready to apply in minutes.
        </p>

        <div className="mt-10 overflow-hidden rounded-2xl border border-white/10 bg-ink text-left" data-id="element-177" data-mp="2c4tayocrt4v2">
          <div className="flex items-center justify-between border-b border-white/10 px-5 py-3 text-xs font-bold uppercase tracking-wide text-white/50" data-id="element-178" data-mp="2837rul9n7ucf">
            <span data-id="element-179" data-mp="2h4xt0itbu7ne">What's included</span>
            <span data-id="element-180" data-mp="2h5z58qm2x06p">Price</span>
          </div>
          {rows.map(r => <div key={r.label} className="flex items-center justify-between gap-4 border-b border-white/5 px-5 py-3.5 text-sm" data-id="element-181" data-mp="rpr9gpwjcr2o">
              <span className="text-white/80" data-id="element-182" data-mp="mt0zmkbbqrpp">{r.label}</span>
              <span className={r.price.startsWith('$') ? 'shrink-0 font-bold text-white' : 'shrink-0 font-bold text-gold'} data-id="element-183" data-mp="2muh9hptt32zh">
                {r.price}
              </span>
            </div>)}
          <div className="flex flex-wrap items-center justify-between gap-2 bg-navy/40 px-5 py-4" data-id="element-184" data-mp="30tqgbyw4gkqs">
            <span className="text-sm font-bold text-white" data-id="element-185" data-mp="35r8lde70qfti">
              Real total value: <span className="text-white/40 line-through" data-id="element-186" data-mp="3aqbminjvo1w7">$70</span>
            </span>
            <span className="text-gold-shine font-display text-2xl font-black" data-id="element-187" data-mp="3fhbhvodcmbwl">$25</span>
          </div>
        </div>

        <div className="mt-9 flex justify-center" data-id="element-188" data-mp="3jidhi6b6gpz3">
          <CTAButton data-id="element-189" data-mp="3jl9ik3ibnurr">✅ I want the Edge + 5 bonuses</CTAButton>
        </div>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs font-medium text-white/50" data-id="element-190" data-mp="3okckvg6x3mw1">
          {trust.map(({
          icon: Icon,
          label
        }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-191" data-mp="7gyatyfo0jv4">
              <Icon className="h-4 w-4 text-gold" data-id="element-192" data-mp="2gsrr6ngo5on" />
              {label}
            </span>)}
        </div>
      </div>
    </section>;
}